import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-notifications-dialog',
  templateUrl: './notifications-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class NotificationsDialog implements OnInit {
  message: any;
  position: any;

  constructor(
    private _dialogRef: MatDialogRef<NotificationsDialog>,
    private _snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    if (this.data.message) {
      this.message = this.data.message;
    }
  }

  openLink() {
    if (this.message.msgLink) {
      let url = this.message.msgLink;
      if (/\S/.test(url) && url != null) {
        if (!url.includes('http://') && !url.includes('https://')) {
          url = 'https://' + url;
        }
        window.open(url, '_blank');
      } else {
        const message = 'no link found';
        this.openSnackBar(message, 'ok');
      }
    }
  }

  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 5000,
      verticalPosition: 'top',
    });
  }

  parseISOString(s) {
    const b = s.split(/\D+/);
    return new Date(Date.UTC(b[0], --b[1], b[2], b[3], b[4], b[5], b[6]));
  }

  isoFormatDMY(d, lastRunDate) {
    const date =
      this.pad(this.pad(d.getUTCMonth() + 1) + '/' + d.getUTCDate()) + '/' + d.getUTCFullYear();
    const time = d.toLocaleTimeString(); // get the local time from full string format
    return date + ' ' + time;
  }

  pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  padd(n) {
    return (n < 100 ? '0' : '') + this.pad(n);
  }

  close() {
    this._dialogRef.close({
      message: this.message,
      postion: this.position,
      action: 'ok',
    });
  }
}
